/*
 * Copyright (c) 2020.  Sanish Manandhar
 * All Rights Reserved
 */
export const NOTIFICATION_CLEAN_REQUEST = 'NOTIFICATION_CLEAN_REQUEST';

export const DASHBOARD_NOTIFICATION_COUNT_FETCH_REQUEST =
  'DASHBOARD_NOTIFICATION_COUNT_FETCH_REQUEST';
export const DASHBOARD_NOTIFICATION_COUNT_FETCH_REQUEST_SUCCESS =
  'DASHBOARD_NOTIFICATION_COUNT_FETCH_REQUEST_SUCCESS';
export const DASHBOARD_NOTIFICATION_COUNT_FETCH_REQUEST_FAILURE =
  'DASHBOARD_NOTIFICATION_COUNT_FETCH_REQUEST_FAILURE';

export const DASHBOARD_NOTIFICATION_FETCH_REQUEST = 'DASHBOARD_NOTIFICATION_FETCH_REQUEST';
export const DASHBOARD_NOTIFICATION_FETCH_REQUEST_SUCCESS =
  'DASHBOARD_NOTIFICATION_FETCH_REQUEST_SUCCESS';
export const DASHBOARD_NOTIFICATION_FETCH_REQUEST_FAILURE =
  'DASHBOARD_NOTIFICATION_FETCH_REQUEST_FAILURE';

export const NOTIFICATION_FETCH_REQUEST = 'NOTIFICATION_FETCH_REQUEST';
export const NOTIFICATION_FETCH_REQUEST_SUCCESS = 'NOTIFICATION_FETCH_REQUEST_SUCCESS';
export const NOTIFICATION_FETCH_REQUEST_FAILURE = 'NOTIFICATION_FETCH_REQUEST_FAILURE';

export const SINGLE_NOTIFICATION_FETCH_REQUEST = 'SINGLE_NOTIFICATION_FETCH_REQUEST';
export const SINGLE_NOTIFICATION_FETCH_REQUEST_SUCCESS =
  'SINGLE_NOTIFICATION_FETCH_REQUEST_SUCCESS';
export const SINGLE_NOTIFICATION_FETCH_REQUEST_FAILURE =
  'SINGLE_NOTIFICATION_FETCH_REQUEST_FAILURE';

export const MARK_NOTIFICATION_AS_READ_REQUEST = 'MARK_NOTIFICATION_AS_READ_REQUEST';
export const MARK_NOTIFICATION_AS_READ_REQUEST_SUCCESS =
  'MARK_NOTIFICATION_AS_READ_REQUEST_SUCCESS';
export const MARK_NOTIFICATION_AS_READ_REQUEST_FAILURE =
  'MARK_NOTIFICATION_AS_READ_REQUEST_FAILURE';

export const NOTIFICATION_PREFERENCE_FETCH_REQUEST = 'NOTIFICATION_PREFERENCE_FETCH_REQUEST';
export const NOTIFICATION_PREFERENCE_FETCH_REQUEST_SUCCESS = 'NOTIFICATION_PREFERENCE_FETCH_REQUEST_SUCCESS';
export const NOTIFICATION_PREFERENCE_FETCH_REQUEST_FAILURE = 'NOTIFICATION_PREFERENCE_FETCH_REQUEST_FAILURE';